// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
var Promise = require('es6-promise').Promise;
import 'babel-polyfill'

import Vue from 'vue'
import router from '@/router'

//import VueResource from 'vue-resource'
//Vue.use(VueResource)

import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		"oServerUrl": {
			"base": "",
			"api": {}
		},
		"oHomePage":{
			index:1,
			size:6,
			oFirstFire:null
		},
		"aIndexMenu": {
			"home": {
				"name": "首页",
				"path": "/"
			},
			"solution": {
				"name": "解决方案",
				"path": "/solution",
				"sub":{
					"2_1":{
						"name":"热门解决方案",
						"path":""
					},
					"2_2":{
						"name":"行内解决方案",
						"path":""
					},
					"2_3":{
						"name":"受益用户",
						"path":""
					}
				}
			},
			"product": {
				"name": "产品&服务",
				"path": "/product",
				"sub":{
					"3_1":{
						"name":"接入服务",
						"path":"/product"
					},
					"3_2":{
						"name":"云主机",
						"path":"/product/2"
					},
					"3_3":{
						"name":"物联网模块",
						"path":"/product/3_1"
					},
					"3_4":{
						"name":"物联网链接器",
						"path":"/product/3_2"
					},
					"3_5":{
						"name":"Qiot Pro",
						"path":"/product/4_1"
					},
					"3_6":{
						"name":"物联网控制系统",
						"path":"/product/4_2"
					}
				}
			},
			"casus": {
				"name": "客户案例",
				"path": "/casus"
			},
			"support": {
				"name": "技术支持",
				"path": "/support/1_1",
				"sub":{
					"5_1":{
						"name":"产品文档",
						"path":"/support/1_1"
					},
					"5_2":{
						"name":"APP使用说明",
						"path":"/support/2_1"
					},
					"5_3":{
						"name":"APP下载",
						"path":"/support/3_1"
					}
				}
			},
			"about": {
				"name": "关于我们",
				"path": "/about",
				"sub":{
					"6_1":{
						"name":"公司简介",
						"path":"/about"
					},
					"6_2":{
						"name":"联系我们",
						"path":"/about/2"
					},
					"6_3":{
						"name":"新闻动态",
						"path":"/about/3_1"
					},
					"6_4":{
						"name":"加入我们",
						"path":"/about/4_1"
					},
					"6_5":{
						"name":"物联网初创企业成长计划",
						"path":"/about/5"
					}
				}
			}
		}
	},
	mutations: {
		homeNext: state => {
			if(state.oHomePage.index < state.oHomePage.size){
				state.oHomePage.index += 1;
				state.oHomePage.oFirstFire = setTimeout(function() {
					state.oHomePage.oFirstFire = null;
				}, 400);
			}
		},
		homeBefore:state=>{
			if(state.oHomePage.index > 1){
				state.oHomePage.index -= 1;
				state.oHomePage.oFirstFire = setTimeout(function() {
					state.oHomePage.oFirstFire = null;
				}, 400);
			}
		}
	}, 
	getters: {
		mobile: state => {
		return true;
//		return false;
//			var sUserAgent = navigator.userAgent.toLowerCase();
//			var android = sUserAgent.match(/android/i) == "android"; //安卓
//			var iphone = sUserAgent.match(/iphone os/i) == "iphone os"; //iphone
//			return android || iphone ? true:false;
		}
	}
})

//ElementUI框架
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
Vue.use(ElementUI)

//日期库
import Moment from 'moment'
Vue.filter("dataFormat", function(value) {
	return Moment(value).format("YYYY年MM月DD日 hh:mm")
})
Vue.config.productionTip = false

//日期格式化
Vue.prototype.dataFormat = function(value, format) {
	return Moment(value).format(format)
}
//跳转路由
Vue.prototype.fnToRouter = function(router) {
	if(router == "/"){
		this.$store.state.oHomePage.index = 1;
	}
	this.$router.push(router);		
	window.scrollTo(0, 0);
}
//跳转外站
Vue.prototype.fnToWebPage = function(url) {
	window.location.href = url
}

new Vue({
	el: '#app',
	store,
	router
})


// WEBPACK FOOTER //
// ./src/main.js